"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reduce;
exports.getAccessToken = getAccessToken;
exports.getActiveIMSOrg = getActiveIMSOrg;
exports.getActiveTabIndex = getActiveTabIndex;
exports.getClientTimestamp = getClientTimestamp;
exports.getDisplayAlertsConfig = getDisplayAlertsConfig;
exports.getEarlierNotifications = getEarlierNotifications;
exports.getEnvironment = getEnvironment;
exports.getFilteredEarlierNotifications = getFilteredEarlierNotifications;
exports.getFilteredNewNotifications = getFilteredNewNotifications;
exports.getFilteredNotificationLoading = getFilteredNotificationLoading;
exports.getFilteredNotifications = getFilteredNotifications;
exports.getFilteredNotificationsById = getFilteredNotificationsById;
exports.getFilteredNotificationsOffset = getFilteredNotificationsOffset;
exports.getLastClickTimestamp = getLastClickTimestamp;
exports.getLastCloseTimestamp = getLastCloseTimestamp;
exports.getLastOpenTimestamp = getLastOpenTimestamp;
exports.getLatestNotificationTimestamp = getLatestNotificationTimestamp;
exports.getLocale = getLocale;
exports.getNewNotifications = getNewNotifications;
exports.getNotificationAlerts = getNotificationAlerts;
exports.getNotificationById = getNotificationById;
exports.getNotificationFilters = getNotificationFilters;
exports.getNotificationLinkValidation = getNotificationLinkValidation;
exports.getNotificationsArray = getNotificationsArray;
exports.getNotificationsById = getNotificationsById;
exports.getNotificationsLoading = getNotificationsLoading;
exports.getPreviousPageTimestamp = getPreviousPageTimestamp;
exports.getSearchQueryForNotificationFilters = getSearchQueryForNotificationFilters;
exports.getServerTime = getServerTime;
exports.getServerTimestamp = getServerTimestamp;
exports.getUnreadNotificationCount = getUnreadNotificationCount;
exports.hasSearchEndReached = hasSearchEndReached;
exports.hasTimelineEndReached = hasTimelineEndReached;
exports.initialState = void 0;
exports.isFlyoutOpen = isFlyoutOpen;
var types = _interopRequireWildcard(require("../actions/actionTypes"));
var Constants = _interopRequireWildcard(require("../../constants/Constants"));
var _NotificationMetadataFilters = _interopRequireDefault(require("../../constants/NotificationMetadataFilters"));
var _compact = _interopRequireDefault(require("lodash/compact"));
var _concat = _interopRequireDefault(require("lodash/concat"));
var _findIndex = _interopRequireDefault(require("lodash/findIndex"));
var _forOwn = _interopRequireDefault(require("lodash/forOwn"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _map = _interopRequireDefault(require("lodash/map"));
var _orderBy = _interopRequireDefault(require("lodash/orderBy"));
var _pickBy = _interopRequireDefault(require("lodash/pickBy"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any. The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/

const initialState = {
  accessToken: '',
  activeIMSOrg: '',
  locale: 'en-US',
  theme: 'lightest',
  environment: 'dev',
  isLoading: {
    widget: false,
    viewAll: false
  },
  byId: {},
  //{}
  notifications: [],
  //[ids]
  alerts: [],
  filteredNotifications: [],
  filteredNotificationsOffset: 0,
  filters: {
    metadata: _NotificationMetadataFilters.default,
    categories: []
  },
  filteredNotificationsById: {},
  isFlyoutOpen: false,
  searchQuery: '',
  activeTabIndex: 0,
  isEndOfTimeline: false,
  isEndOfSearch: false,
  validLink: true,
  lastClickTimestamp: Date.now(),
  //TODO: Need to document the purpose of each timestamp stored in state.
  lastOpenTimestamp: Date.now(),
  lastCloseTimestamp: Date.now(),
  lastNotificationSeenTimestamp: Date.now(),
  previousPageTimestamp: 123,
  clientTimestamp: 124,
  serverTimestamp: 125,
  displayAlertsConfig: Constants.DEFAULT_DISPLAY_ALERTS
};
exports.initialState = initialState;
function reduce() {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  let action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const payload = action.payload;
  let notificationsById, filteredNotificationsById;
  switch (action.type) {
    case types.NOTIFICATIONS_CONFIG_FETCHED:
      return {
        ...state,
        accessToken: payload.accessToken,
        activeIMSOrg: payload.activeIMSOrg,
        locale: payload.locale,
        environment: payload.environment
      };
    case types.ACTIVE_IMS_ORG_CHANGED:
      return {
        ...state,
        ...payload,
        byId: {},
        notifications: [],
        alerts: [],
        activeTabIndex: 0
      };
    case types.NOTIFICATIONS_FETCHED:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          widget: false
        },
        byId: {
          ...{
            ...state.byId
          },
          ...{
            ...payload.notificationsById
          }
        },
        notifications: payload.isLoadMore ? (0, _compact.default)((0, _concat.default)(state.notifications, (0, _map.default)((0, _orderBy.default)(payload.notificationsById, 'sortedTimestamp', 'desc'), 'id'))) : (0, _compact.default)((0, _map.default)((0, _orderBy.default)(payload.notificationsById, 'sortedTimestamp', 'desc'), 'id')),
        isEndOfTimeline: state.previousPageTimestamp === payload.previousPageTimestamp,
        previousPageTimestamp: payload.previousPageTimestamp
      };
    case types.NOTIFICATIONS_LOADING:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          widget: true
        }
      };
    case types.NOTIFICATIONS_FAILURE:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          widget: false
        }
      };
    case types.LONG_POLL_NOTIFICATIONS_FETCHED:
      const newEntries = (0, _pickBy.default)(action.notificationsById, entry => (0, _findIndex.default)(state.notifications, id => id === entry.id) < 0);
      if (!(0, _isEmpty.default)(newEntries)) {
        const newNotifAsArray = (0, _map.default)((0, _orderBy.default)(newEntries, 'sortedTimestamp', 'desc'), 'id');
        let newAlerts = [...state.alerts];
        if (!state.isFlyoutOpen) {
          //Alerts should show up if the flyout is not open and the priority of the notifications is high
          let filteredNotifs;
          switch (state.displayAlertsConfig.type) {
            case 'NONE':
              filteredNotifs = [];
              break;
            case 'ALL':
              filteredNotifs = newNotifAsArray;
              break;
            default:
              filteredNotifs = newNotifAsArray.filter(entry => newEntries[entry].priority.toLowerCase() === Constants.HIGH);
              break;
          }
          newAlerts = [...state.alerts.slice(0), ...filteredNotifs];
        }
        return {
          ...state,
          byId: {
            ...{
              ...state.byId
            },
            ...{
              ...newEntries
            }
          },
          notifications: (0, _compact.default)((0, _concat.default)(newNotifAsArray, state.notifications)),
          alerts: newAlerts
        };
      }
      return state;
    case types.NOTIFICATIONS_UPDATED:
      return {
        ...state,
        byId: {
          ...{
            ...state.byId
          },
          ...{
            ...action.notificationsById
          }
        },
        filteredNotificationsById: {
          ...{
            ...state.filteredNotificationsById
          },
          ...{
            ...action.notificationsById
          }
        }
      };
    case types.LATEST_SERVER_TIMESTAMP_FETCHED:
      return {
        ...state,
        serverTimestamp: action.serverTimestamp,
        clientTimestamp: Date.now()
      };
    case types.MARK_NOTIFICATIONS_AS_SHOWN:
      return {
        ...state,
        alerts: state.alerts.filter(item => {
          let found = false;
          for (let i = 0; i < action.ids.length; ++i) {
            if (item === action.ids[i]) {
              found = true;
              break;
            }
          }
          return !found;
        })
      };
    case types.SET_REMINDER_ON_NOTIFICATION:
      notificationsById = state.byId;
      if (state.byId && state.byId[payload.id]) {
        notificationsById = {
          ...state.byId,
          [payload.id]: {
            ...state.byId[payload.id],
            reminderTime: payload.reminderTime
          }
        };
      }
      filteredNotificationsById = state.filteredNotificationsById;
      if (state.filteredNotificationsById[payload.id]) {
        filteredNotificationsById = {
          ...state.filteredNotificationsById,
          [payload.id]: {
            ...state.filteredNotificationsById[payload.id],
            reminderTime: payload.reminderTime
          }
        };
      }
      return {
        ...state,
        byId: notificationsById,
        filteredNotificationsById
      };
    case types.REMOVE_REMINDER_ON_NOTIFICATION:
      // eslint-disable-next-line no-unused-vars
      const {
        reminderTime,
        ...noReminderTime
      } = {
        ...state.byId[payload.id]
      };
      filteredNotificationsById = state.filteredNotificationsById;
      if (state.filteredNotificationsById[payload.id]) {
        filteredNotificationsById = {
          ...state.filteredNotificationsById,
          [payload.id]: noReminderTime
        };
      }
      return {
        ...state,
        byId: {
          ...state.byId,
          [payload.id]: noReminderTime
        },
        filteredNotificationsById
      };
    case types.SET_LAST_USER_CLICK_TIMESTAMP:
      return {
        ...state,
        lastClickTimestamp: payload
      };
    case types.MARK_NOTIFICATION_AS_UNREAD:
      return {
        ...state,
        byId: {
          ...state.byId,
          [payload.id]: {
            ...state.byId[payload.id],
            isRead: false
          }
        }
      };
    case types.MARK_NOTIFICATION_AS_READ:
      return {
        ...state,
        byId: {
          ...state.byId,
          [payload.id]: {
            ...state.byId[payload.id],
            isRead: true
          }
        }
      };
    case types.TOGGLE_NOTIFICATION_READ_STATUS:
      //mark in the main array, mark in the filtered array
      notificationsById = state.byId;
      if (state.byId && state.byId[payload.id]) {
        notificationsById = {
          ...state.byId,
          [payload.id]: {
            ...state.byId[payload.id],
            isRead: !state.byId[payload.id].isRead
          }
        };
      }
      filteredNotificationsById = state.filteredNotificationsById;
      if (state.filteredNotificationsById[payload.id]) {
        filteredNotificationsById = {
          ...state.filteredNotificationsById,
          [payload.id]: {
            ...state.filteredNotificationsById[payload.id],
            isRead: !state.filteredNotificationsById[payload.id].isRead
          }
        };
      }
      return {
        ...state,
        byId: notificationsById,
        filteredNotificationsById
      };
    case types.FILTERED_NOTIFICATIONS_FETCHED:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          viewAll: false
        },
        filteredNotificationsById: {
          ...state.filteredNotificationsById,
          ...payload.notificationsById
        },
        filteredNotifications: [...(0, _map.default)((0, _orderBy.default)(payload.notificationsById, 'sortedTimestamp', 'desc'), 'id')],
        filteredNotificationsOffset: payload.offset,
        searchQuery: payload.searchQuery,
        isEndOfSearch: payload.isEndReached
      };
    case types.FILTERED_NOTIFICATIONS_LOADING:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          viewAll: true
        }
      };
    case types.FILTERED_NOTIFICATIONS_FAILURE:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          viewAll: false
        }
      };
    case types.PAGINATED_FILTEREDNOTIFICATION_FETCHED:
      return {
        ...state,
        filteredNotificationsById: {
          ...state.filteredNotificationsById,
          ...payload.notificationsById
        },
        filteredNotifications: [...state.filteredNotifications, ...(0, _map.default)((0, _orderBy.default)(payload.notificationsById, 'sortedTimestamp', 'desc'), 'id')],
        filteredNotificationsOffset: payload.offset,
        isEndOfSearch: payload.isEndReached
      };
    case types.NOTIFICATION_FILTERS_FETCHED:
      return {
        ...state,
        filters: {
          ...{
            ...state.filters
          },
          categories: payload
        }
      };
    case types.MARK_ALL_NOTIFICATION_AS_READ:
      //create a new copy, update the notification status to read and replace the state
      const copy = {
        ...state.byId
      };
      const newCopy = {};
      (0, _forOwn.default)(copy, (value, key) => {
        value.isRead = true;
        newCopy[key] = value;
      });
      //also update the filtered store
      const filteredCopy = {
        ...state.filteredNotificationsById
      };
      const filteredNewCopy = {};
      (0, _forOwn.default)(filteredCopy, (value, key) => {
        value.isRead = true;
        filteredNewCopy[key] = value;
      });
      return {
        ...state,
        byId: newCopy,
        filteredNotificationsById: filteredNewCopy
      };
    case types.SET_FLYOUT_LAST_OPEN_TIMESTAMP:
      return {
        ...state,
        lastOpenTimestamp: payload,
        isFlyoutOpen: true
      };
    case types.SET_FLYOUT_LAST_CLOSE_TIMESTAMP:
      return {
        ...state,
        lastCloseTimestamp: payload,
        isFlyoutOpen: false
      };
    case types.ACTIVE_TAB_INDEX_CHANGED:
      return {
        ...state,
        activeTabIndex: payload
      };
    case types.DISPLAY_ALERTS_FETCHED:
      return {
        ...state,
        displayAlertsConfig: payload
      };
    case types.NOTIFICATION_URL_LINK_VALIDATION:
      return {
        ...state,
        validLink: payload
      };
    case types.SET_LAST_NOTIFICATION_SEEN_TIMESTAMP:
      /*
        * lastNotificationSeenTimestamp is for showing New and Earlier sections
        * as current behaviour is on opening flyout, remove the counter from bell icon
        * in unified-shell but still group the notifications into new and early
        */
      return {
        ...state,
        lastNotificationSeenTimestamp: payload
      };
    default:
      return state;
  }
}
function getNotificationLinkValidation(state) {
  return state.notifications.validLink;
}
function getNotificationById(state, id) {
  let notification = state.notifications.byId && state.notifications.byId[id];
  if (!notification) {
    notification = state.notifications.filteredNotificationsById && state.notifications.filteredNotificationsById[id];
  }
  return notification;
}
function getPreviousPageTimestamp(state) {
  return state.notifications.previousPageTimestamp;
}
function getNotificationsById(state) {
  return state.notifications.byId;
}
function getNotificationsLoading(state) {
  return state.notifications.isLoading.widget;
}
function getNotificationsArray(state) {
  return state.notifications.notifications;
}
function getLastClickTimestamp(state) {
  return state.notifications.lastClickTimestamp;
}
function getNewNotifications(state) {
  if (state.notifications && state.notifications.notifications) {
    return state.notifications.notifications.filter(entry => state.notifications.byId[entry].sortedTimestamp > state.notifications.lastNotificationSeenTimestamp);
  }
  return [];
}
function getEarlierNotifications(state) {
  return state.notifications.notifications.filter(entry => state.notifications.byId[entry].sortedTimestamp < state.notifications.lastNotificationSeenTimestamp);
}
function getFilteredNewNotifications(state) {
  if (state.notifications.filteredNotifications) {
    return state.notifications.filteredNotifications.filter(entry => state.notifications.filteredNotificationsById[entry].sortedTimestamp > state.notifications.lastNotificationSeenTimestamp);
  }
  return [];
}
function getFilteredEarlierNotifications(state) {
  if (state.notifications.filteredNotifications) {
    return state.notifications.filteredNotifications.filter(entry => state.notifications.filteredNotificationsById[entry].sortedTimestamp < state.notifications.lastNotificationSeenTimestamp);
  }
  return [];
}

/**
 * Should not use Date.now() in it.
 * @param state
 */
function getServerTime(state) {
  const serverTimestamp = state.notifications.serverTimestamp;
  const clientTimestamp = state.notifications.clientTimestamp;
  const timeNow = Date.now();
  return serverTimestamp + timeNow - clientTimestamp;
}
function getServerTimestamp(state) {
  return state.notifications.serverTimestamp;
}
function getClientTimestamp(state) {
  return state.notifications.clientTimestamp;
}
function getNotificationFilters(state) {
  return state.notifications.filters;
}
function getLatestNotificationTimestamp(state) {
  if (state.notifications.notifications.length > 0) {
    return state.notifications.byId[state.notifications.notifications[0]].sortedTimestamp;
  }
  return 0;
}
function getFilteredNotificationsById(state) {
  return state.notifications.filteredNotificationsById;
}
function getFilteredNotificationLoading(state) {
  return state.notifications.isLoading.viewAll;
}
function getFilteredNotifications(state) {
  return state.notifications.filteredNotifications;
}
function getFilteredNotificationsOffset(state) {
  return state.notifications.filteredNotificationsOffset;
}
function getSearchQueryForNotificationFilters(state) {
  return state.notifications.searchQuery;
}
function getUnreadNotificationCount(state) {
  let count = 0;
  (0, _forOwn.default)(state.notifications.byId, value => {
    if (!value.isRead) {
      count++;
    }
  });
  return count;
}
function getLastOpenTimestamp(state) {
  return state.notifications.lastOpenTimestamp;
}
function getLastCloseTimestamp(state) {
  return state.notifications.lastCloseTimestamp;
}
function getAccessToken(state) {
  return state.notifications.accessToken;
}
function getLocale(state) {
  return state.notifications.locale;
}
function getActiveIMSOrg(state) {
  return state.notifications.activeIMSOrg;
}
function getEnvironment(state) {
  return state.notifications.environment;
}
function isFlyoutOpen(state) {
  return state.notifications.isFlyoutOpen;
}
function getActiveTabIndex(state) {
  return state.notifications.activeTabIndex;
}
function hasTimelineEndReached(state) {
  return state.notifications.isEndOfTimeline;
}
function hasSearchEndReached(state) {
  return state.notifications.isEndOfSearch;
}
function getNotificationAlerts(state) {
  return state.notifications.alerts;
}
function getDisplayAlertsConfig(state) {
  return state.notifications.displayAlertsConfig;
}